
import { useState } from 'react';
import { Vendor } from '@/types';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import VendorSelect from '@/components/VendorSelect';
import FileUpload from '@/components/FileUpload';
import ProcessingHistory from '@/components/ProcessingHistory';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

const Index = () => {
  const [selectedVendor, setSelectedVendor] = useState<Vendor | null>(null);
  const [activeTab, setActiveTab] = useState('upload');

  const handleVendorSelect = (vendor: Vendor | null) => {
    setSelectedVendor(vendor);
  };

  const handleTabChange = (value: string) => {
    setActiveTab(value);
  };

  const handleGoToHistory = () => {
    setActiveTab('history');
  };

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="container mx-auto px-4 max-w-full">
        <h1 className="text-2xl font-bold text-center mb-2">Vendor Price Update</h1>
        <p className="text-gray-500 text-center mb-8">
          Upload CSV files for vendor price updates
        </p>
        
        <Tabs 
          defaultValue="upload" 
          value={activeTab}
          onValueChange={handleTabChange} 
          className="w-full"
        >
          <TabsList className="grid w-full grid-cols-2 mb-6">
            <TabsTrigger value="upload">Upload CSV File</TabsTrigger>
            <TabsTrigger value="history">History</TabsTrigger>
          </TabsList>
          
          <TabsContent value="upload">
            <Card>
              <CardHeader>
                <CardTitle>Upload Vendor CSV File</CardTitle>
                <CardDescription>
                  Select a vendor and upload a CSV file to update pricing information
                </CardDescription>
              </CardHeader>
              <CardContent className="space-y-6">
                <VendorSelect onVendorSelect={handleVendorSelect} />
                <FileUpload 
                  selectedVendor={selectedVendor}
                  onSuccessAction={handleGoToHistory}  
                />
              </CardContent>
            </Card>
          </TabsContent>
          
          <TabsContent value="history">
            <ProcessingHistory 
              selectedVendor={selectedVendor} 
              onVendorSelect={handleVendorSelect}
            />
          </TabsContent>
        </Tabs>
        
        <div className="mt-6 text-center text-sm text-gray-500">
          <p>Only CSV files are supported. Maximum file size: 50MB.</p>
        </div>
      </div>
    </div>
  );
};

export default Index;
